import React from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminBreadcrumbs from '../../components/Admin/Breadcrumbs';
import AdminReportsWidget from '../../components/Admin/Reports/Widget';
import TrialNotice from '../../components/TrialNotice';
import UpgradePlanButton from '../../components/UpgradePlanButton';

import { reports } from '../../helpers/Reports';

const AdminReports = () => {
  const intl = useIntl();

  return (
    <div className="main-content reports-content">
      <Container fluid>
        <AdminBreadcrumbs />
        <header className="page-header with-upgrade-button">
          <h2 className="page-title">
            <i className="far fa-file-chart-pie" />
            {intl.formatMessage({ defaultMessage: 'Reports' })}
          </h2>
          <UpgradePlanButton feature="reports" />
        </header>
        <TrialNotice feature="reports" />
        <div className="content-wrapper">
          <Row>
            {reports(intl).filter(r => (r.widget)).map(widget => (
              <Col key={widget.id} xs="12" xl="6">
                <AdminReportsWidget widget={widget} />
              </Col>
            ))}
          </Row>
          <Nav className="ml-auto nav-main settings reports-list">
            {reports(intl).filter(r => (!r.widget)).map(report => (
              <NavItem key={report.id}>
                <NavLink tag={Link} to={`/admin/reports/${report.id}`}>
                  <i className={`far ${report.icon || 'fa-file-chart-pie'}`} />
                  <div className="settings-description">
                    <h5>{report.name}</h5>
                  </div>
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </div>
      </Container>
    </div>
  );
};

export default AdminReports;
